import {useEffect, useState} from "react";
import {useUserInfoGetter} from "./hooks/useUserInfoGetter";
import {useCookie} from "../../hooks/auth/useCookie";
import {CookieKeys} from "../../hooks/auth/AuthProvider";
import {useNavigate} from "react-router-dom";
import {useAuth} from "../../hooks/hooks";
declare global {
    interface Window {
        wcs: any;
        wcs_add?: any;
    }
}

export function GoogleAnalytics() {
    const navigate = useNavigate();
    const {getUserInfo, user} = useUserInfoGetter();
    const {getValueFromCookie} = useCookie();
    const accessToken = getValueFromCookie(CookieKeys.ACCESS_TOKEN);
    const [eventFired, setEventFired] = useState(false);
    const {isLoggedIn} = useAuth();

    useEffect(() => {
        if (!isLoggedIn) return;
        // eslint-disable-next-line
    }, []);


    useEffect(() => {
        if (accessToken) {
            getUserInfo().then();
        }
    }, [accessToken, getUserInfo]);


    // ga4 이벤트 수집
    useEffect(() => {
        initializeGA4();

        // eslint-disable-next-line
    }, [navigate,
        // accessToken, user, eventFired
    ]);


    // ga4 초기화
    const initializeGA4 = () => {
        const userId = user ? user.idx : 'unsigned_user';

        // GA4 라이브러리 추가
        const script1 = document.createElement('script');
        script1.src = "https://www.googletagmanager.com/gtag/js?id=G-SVYQXKM5PD";
        script1.async = true;
        window.gtag('js', new Date());

        const handleScriptLoad = () => {
            // 사용자 로그인 상태 체크 이벤트
            window.gtag('config', 'G-SVYQXKM5PD', {
                'user_id': userId,
            });

            // 현재 페이지 제목 체크 이벤트
            window.gtag('event', 'page_view', {
                'page_title': checkCurrentPageInfo(),
                'page_path': window.location.pathname
            });
            // console.log('GA4 userId 추가 : ', userId);
            // console.log('GA4 페이지 경로 추가 : ', checkCurrentPageInfo());
        };


        // 최초 접근 시 이벤트 한번만 발생하도록 조건 처리
        if (!eventFired && ((accessToken && user !== undefined) || (!accessToken && !user))) {
            setEventFired(true);
            script1.onload = handleScriptLoad;
            document.head.appendChild(script1);

            return () => {
                document.head.removeChild(script1);
            };
        }

        // 최초 접근 이후 페이지 이동 이벤트 감지
        if (eventFired) {
            // setIsFirstLoaded(false);
            script1.onload = handleScriptLoad;
            document.head.appendChild(script1);

            return () => {
                document.head.removeChild(script1);
            };
        }
    };

    // 사용자 홈페이지 이용 경로 트래킹
    const checkCurrentPageInfo = () => {
        const pathTitleMap = [
            {path: 'startguide', title: "시작 가이드"},
            {path: 'understanding/dcas', title: "검사의 이해"},
            {path: 'understanding/history', title: "역사"},
            {path: 'understanding/academic-basis', title: "학술적 근거"},
            {path: 'purchase-voucher', title: "이용권 구매 페이지"},
            {path: 'download-test', title: "검사 다운로드 페이지"},
            {path: 'partnership', title: "제휴 문의 페이지"},
            {path: 'review', title: "리얼 후기 페이지"},
            {path: 'order', title: "주문 페이지"},
            {path: 'mypage', title: "마이 페이지"},
            {path: 'payment-result', title: "주문 완료 페이지"},
            {path: 'partnerlist', title: "협력사"}
        ];

        const currentPath = window.location.pathname;
        const matchedPath = pathTitleMap.find(mapping => currentPath.includes(mapping.path));

        return matchedPath ? matchedPath.title : "뇌 기반 재능 발굴의 시작 디카스";
    };

    return (
        <>
        </>
    )
}